import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import BlankColumnContent from '../../../../../../../src/components/common/blank-column-content';
import Text, { H4 } from '../../../../../../../src/components/common/text';
import {
  Currency,
  ChangeIndicatedPercent,
  ChangeIndicatedNumber,
} from '../../../../../../../src/components/common/number';
import { NO_DATA } from '../../../../../../../src/constants';
import styles from './chart-header.styles';
import SimpleDate from '../../../../../../../src/components/common/date';

class ChartHeader extends PureComponent {
  static propTypes = {
    dayChange: PropTypes.number,
    dayChangePercentage: PropTypes.number,
    value: PropTypes.number,
    valueUnit: PropTypes.string,
    testID: PropTypes.string,
    valueLabel: PropTypes.string,
    dayChangeLabel: PropTypes.string,
  };

  static defaultProps = {
    testID: 'header',
    valueLabel: 'Security Price',
    dayChangeLabel: 'Price Change',
    priceDateLabel: 'Price Date'
  };

renderValue() {
    const { value, valueUnit, valueLabel, messages} = this.props;
    const fractions = {maximumFractionDigits: 2, minimumFractionDigits: 2};
    let valueText = messages['app.common.portfolio.fxRate'];

    if(valueLabel == valueText) {
      return(
        <Text>{value != null ? value : NO_DATA}</Text>
      );
    }
    return (
      <Currency
        renderProps={{
          style: value == null ? styles.itemValueBlank : undefined,
          size: 'large',
          testID: 'value',
        }}
        value={value != null ? value : NO_DATA}
        currency={valueUnit}
        {...fractions}
      />
    );
  }

  renderDayChangeValue() {
    const { dayChange, dayChangePercentage } = this.props;

    if (dayChange == null || dayChangePercentage == null) {
      return <BlankColumnContent />;
    }

    return (
      <H4 style={styles.itemValue} testID="value">
        <ChangeIndicatedNumber
          value={dayChange}
          withPlusSign
        />
        &nbsp;
        <ChangeIndicatedPercent value={dayChangePercentage} withPlusSign>
          {
            (text, props) =>
              <Text {...props}>
                ({ text })
              </Text>
          }
        </ChangeIndicatedPercent>
      </H4>
    );
  }
  // JIRA #2975, Remove the Price change
  render() {
    const {
      valueLabel,
      dayChangeLabel,
      testID,
      priceDateLabel,
      priceDateValue,
      assetCategory,
      assetGroupId,
      assetShortDesc,
      messages
    } = this.props;

    if(assetShortDesc == 'cash' || assetShortDesc == 'mmDeposites' || assetShortDesc == 'credit') {
      return (<View></View>);
    }

    return (
      <View style={styles.root} testID={testID}>
        <View style={styles.itemLeft} testID="balance-or-price">
          <Text style={styles.itemLabel} testID="label">{messages['app.common.portfolio.alter.mktPrice']}</Text>
          <Text style={[styles.itemLabel, styles.marginValue]} testID="label">{messages['app.portfolio.assetDetails.priceDate']}</Text>
        </View>


          <View style={styles.itemRight} testID="balance-or-price">
            {this.renderValue()}
              <View style={styles.marginValue}>
                <SimpleDate value={priceDateValue}/>
              </View>
          </View>

        {/*
        <View style={styles.itemSeparator} />
        <View style={styles.itemRight} testID="day-change">
           // JIRA #2975, Remove the Price change
          <Text style={styles.itemLabel} testID="label">{dayChangeLabel}</Text>
          {this.renderDayChangeValue()}
        </View>
        */}
      </View>
    );
  }
}

export default ChartHeader;
